import React from "react";
import {
  Create,
  SimpleForm,
  useRedirect,
  useRefresh,
  ReferenceInput,
  SelectInput,
  CreateProps,
  required,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import { GetParam, StudentResources } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import BusScheduleByBusSchedulePlanInput from "./components/BusScheduleByBusSchedulePlanInput";
import CustomDatePickerInput from "components/CustomDatePickerInput";
import moment from "moment";

const NotTakingReportCreate = (props: CreateProps) => {
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();

  let breadcrumbValue = [{ link: "", title: "", params: "" }];

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Not Taking Report",
        link: `/students/${param.get("studentId")}/show/2`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: "",
      },
      {
        title: "Not Taking Report",
        link: `/students/${param.get("studentId")}/show/2`,
        params: "",
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  const studentResources = StudentResources(Number(param.get("studentId")));

  const CustomRedirect = (props: { data: IStudentAddress }) => {
    redirect(`/students/${props.data.studentId}/show/2`);
    refresh();
  };

  const transform = async (data: any) => {
    if (data) {
      data.busSchedulePlanIds = [data.busSchedulePlanId];

      delete data.busSchedulePlanId;
    }

    return data;
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">New Not Taking Report</Typography>
      <Create transform={transform} onSuccess={CustomRedirect} {...props}>
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>
            <Grid item xs={3}>
              <ReferenceInput
                label="Select Student"
                source="studentId"
                reference="students"
                disabled
              >
                <SelectInput
                  optionText={(choice: any) =>
                    `${choice.firstName} ${choice.lastName}`
                  }
                />
              </ReferenceInput>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Select Wave</Typography>
            </Grid>
            <Grid item xs={3}>
              {studentResources && (
                <BusScheduleByBusSchedulePlanInput
                  source="busSchedulePlanId"
                  studentId={studentResources.id}
                  label="Select Wave"
                  validate={required()}
                />
              )}
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomDatePickerInput
                name="date"
                label="Date *"
                min={moment().format("Y-MM-DD")}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default NotTakingReportCreate;
